import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {PushNotificationsService} from "@app/main/content/push-notifications/push-notifications.service";

@Component({
  selector: 'menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit {
  @Input() items: any[];
  @ViewChild('childMenu') public childMenu;
  constructor(private _pushNotificationsService: PushNotificationsService) { }

  ngOnInit() {
  }

  selectedMenuItems(value) {
    this._pushNotificationsService.selectedMenuItem = value;
  }

}
